(function () {

    'use strict';

    angular.module('iplusjs.fieldset', [
        'lodash'
    ])
        .component('iplusjsFieldset', {
            templateUrl: 'common/fieldset/fieldset.html',
            require: {
                form: '?^form'
            },
            bindings: {
                disabled: '<ifsDisabled',
                disableOnSubmit: '<ifsDisableOnSubmit',
                cssClass: '@ifsCssClass'
            },
            transclude: true,
            controller: FieldsetController,
            controllerAs: 'fieldsetVm'
        });

    FieldsetController.$inject = [
        'lodash'
    ];
    function FieldsetController(_) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.isDisabled = isDisabled;

        function activate() {}

        function onInit() {
            activate();
            vm.disableOnSubmit = _.isNil(vm.disableOnSubmit) ? true : vm.disableOnSubmit;
        }

        function onChanges() {
            activate();
        }

        function isDisabled() {
            return (
                vm.disabled ||
                (
                    vm.disableOnSubmit &&
                    vm.form &&
                    vm.form.submitInProgress
                )
            );
        }
    }

})();
